<template>
  <div class="apply-step3">
    <!-- 顶部导航 -->
    <div class="top-nav">
      <!-- 左侧返回按钮 -->
      <div class="back-btn" @click="$router.go(-1)">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </div>

      <!-- 标题 真正居中 -->
      <div class="title-wrapper">
        <h1 class="title">支付确认</h1>
      </div>
    </div>

    <!-- 步骤条 -->
    <div class="step-bar">
      <div class="step-item done">
        <div class="step-circle">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>
        <span>身份选择</span>
      </div>
      <div class="line done"></div>
      <div class="step-item done">
        <div class="step-circle">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>
        <span>填写信息</span>
      </div>
      <div class="line done"></div>
      <div class="step-item active">
        <div class="step-circle">3</div>
        <span>支付确认</span>
      </div>
    </div>

    <!-- 联盟认证费用提示 -->
    <div class="info-tip">
      <div class="tip-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#165DFF" stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
      </div>
      <div class="tip-text">
        为保障联盟生态合作单位质量，申请加入需缴纳认证审核费用。请向以下对公账户转账，并上传转账凭证。
      </div>
    </div>

    <!-- 认证费用 -->
    <div class="form-section">
      <h2 class="section-title">认证费用</h2>
      <div class="form-card">
        <div class="price-box">
          <span class="unit">¥</span>
          <span class="price">399</span>
          <!-- <span class="unit">/年</span> -->
           <span class="unit"></span>
        </div>
        <div class="benefit-list">
          <div class="benefit-item">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0fb864" stroke-width="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
            <span>包含联盟生态合作单位资格审核费用</span>
          </div>
          <div class="benefit-item">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0fb864" stroke-width="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
            <span>享受联盟内供需对接服务</span>
          </div>
          <div class="benefit-item">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0fb864" stroke-width="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
            <span>参与联盟举办的行业活动</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 对公账户信息 -->
    <div class="form-section">
      <h2 class="section-title">对公账户信息</h2>
      <div class="form-card">
        <div class="account-item">
          <span class="label">账户名称</span>
          <span class="value">星飞煌(深圳)传媒有限公司</span>
        </div>
        <div class="account-item">
          <span class="label">开户银行</span>
          <span class="value">平安银行深圳前海分行营业部</span>
        </div>
        <div class="account-item">
          <span class="label">银行账号</span>
          <div class="account-code-wrap">
            <span class="value">{{ bankCode }}</span>
            <div class="copy-btn" @click="copyAccount">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
              </svg>
            </div>
          </div>
        </div>
        <div class="account-item">
          <span class="label">转账金额</span>
          <span class="value red">¥399.00</span>
        </div>
        <div class="pay-qrcode-card">
          <div class="pay-qrcode-title">扫码付款</div>
          <img :src="paymentQr" class="pay-qrcode-img" alt="付款码">
          <div class="pay-qrcode-tip">支持直接扫码付款，付款后请上传转账或付款截图作为凭证。</div>
        </div>
      </div>
    </div>

    <!-- 上传转账凭证 -->
    <div class="form-section">
      <h2 class="section-title">上传转账凭证</h2>
      <div class="form-card">
        <!-- 上传框 -->
        <div class="upload-box" v-if="!uploadFile">
          <input
            ref="uploadRef"
            class="native-file-input"
            type="file"
            accept="image/*"
            @click="resetFileInput"
            @change="handleUpload"
          />
          <div class="upload-placeholder">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <circle cx="8.5" cy="8.5" r="1.5"></circle>
              <polyline points="21 15 16 10 5 21"></polyline>
            </svg>
            <p class="upload-text">上传转账截图</p>
            <p class="upload-tip">支持jpg、png，请确保截图清晰可见</p>
          </div>
        </div>

        <!-- 已上传文件预览 -->
        <div class="file-preview" v-if="uploadFile">
          <img :src="uploadPreview" class="preview-img" />
          <div class="file-info">
            <p class="file-name">{{ uploadFile.name }}</p>
            <p class="file-status">{{ uploading ? '上传中...' : '上传成功' }} · {{ formatSize(uploadFile.size) }}</p>
          </div>
          <div class="delete-btn" @click="removeUpload">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ff4d4f" stroke-width="2">
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- 提交按钮 -->
    <button class="submit-btn" :class="{ disabled: uploading }" @click="submitForm">
      {{ uploading ? '凭证上传中...' : '确认提交申请' }}
    </button>
    <p class="tip-text">提交后，我们将在1-3个工作日内完成审核</p>
  </div>
</template>

<script>
import paymentQr from '@/assets/_cgi-bin_mmwebwx-bin_webwxgetmsgimg__&MsgID=4802028223782932175&skey=@crypt_82e28dba_778beb39a2abee87d5992bb7b59bdfc4&mmweb_appid=wx_webfilehelper.jpeg'

export default {
  name: 'ApplyStep3',
  data() {
    return {
      formData:{},
      bankCode:'1500 0451 9718 39',
      paymentQr,
      uploadFile: null,
      uploadPreview: '',
      uploading: false,
      submitting: false
    }
  },
  mounted () {
    const stepData = this.$store.state.step1Data;
    this.formData = stepData.formData;
  },
  methods: {
    resetFileInput(e) {
      // 允许连续选择同一张图片，并兼容微信内置浏览器。
      e.target.value = ''
    },
    handleUpload(e) {
      const file = e.target.files[0]
      if (!file) return
      if (file.size > 5 * 1024 * 1024) {
        this.$toast.error('图片大小不能超过5MB')
        return
      }
      let formData = new FormData()
      formData.append('file', file) // 后端一般接收 file 字段
      this.uploading = true
      this.$ajax.post('/api/resourceFile/upload', formData).then((res) => {
        if(res.data.code == 200){
          this.formData.paymentReceiptFileId = res.data.data
        } else {
          this.uploadFile = null
          this.uploadPreview = ''
          this.$toast.error(res.data.message || '图片上传失败，请重新选择')
        }
      }).catch(() => {
        this.uploadFile = null
        this.uploadPreview = ''
        this.$toast.error('图片上传失败，请稍后重试')
      }).finally(() => {
        this.uploading = false
      })
      this.uploadFile = file
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.uploadPreview = reader.result
      }
    },
    removeUpload() {
      this.uploadFile = null
      this.uploadPreview = ''
      this.formData.paymentReceiptFileId = null
    },
    formatSize(bytes) {
      if (bytes < 1024) return bytes + 'B'
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + 'KB'
      return (bytes / 1024 / 1024).toFixed(1) + 'MB'
    },
    copyAccount() {
      const text = this.bankCode
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.$toast.success('账号已复制')
        }).catch(this.copyAccountFallback)
        return
      }
      this.copyAccountFallback()
    },
    copyAccountFallback() {
      const input = document.createElement('textarea')
      input.value = this.bankCode
      input.setAttribute('readonly', 'readonly')
      input.style.position = 'fixed'
      input.style.left = '-9999px'
      document.body.appendChild(input)
      input.select()
      const ok = document.execCommand('copy')
      document.body.removeChild(input)
      if (ok) {
        this.$toast.success('账号已复制')
      } else {
        this.$toast.error('复制失败，请手动复制')
      }
    },
    submitForm() {
      if (this.submitting) return
      if (!this.uploadFile) {
        this.$toast.error('请上传转账凭证')
        return
      }
      if (this.uploading || !this.formData.paymentReceiptFileId) {
        this.$toast.error('转账凭证仍在上传，请稍后提交')
        return
      }
      // 提交逻辑
      this.submitting = true
      this.$ajax.post('/api/company/join',this.formData).then((res) => {
        if(res.data.code == 200){
          this.$toast.success('提交成功，等待审核')
          let user = JSON.parse(sessionStorage.getItem('userInfo') || '{}')
          user.companyApplyState = 0
          user.memberType = 'ENTERPRISE'
          sessionStorage.setItem('userInfo',JSON.stringify(user))
          this.$store.commit('CLEAR_STEP1')
          setTimeout(() => {
            this.$router.replace('/apply')
          }, 1000);
        }else{
          this.$toast.error(res.data.message || '提交失败')
        }
      }).catch(() => {
        this.$toast.error('提交失败，请稍后重试')
      }).finally(() => {
        this.submitting = false
      })
      
    }
  }
}
</script>

<style scoped>
.apply-step3 {
  background-color: #f8fafc;
  min-height: 100vh;
  padding-bottom: 100px;
  font-size: 12px;
}
/* 顶部导航 */
.top-nav {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 10;
  position: relative; /* 关键 */
}
.back-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 11;
}
/* 标题容器：绝对居中，不受左右影响 */
.title-wrapper {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  pointer-events: auto;
}
/* 步骤条 */
.step-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 20px;
  background: #fff;
  font-size: 10px;
}
.step-item {
  display: flex;
  align-items: center;
  color: #999;
}
.step-item.done, .step-item.active {
  color: #165DFF;
}
.step-circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #e5e7eb;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  margin-right: 6px;
}
.step-item.done .step-circle {
  background: #0fb864;
  color: #fff;
}
.step-item.active .step-circle {
  background: #165DFF;
  color: #fff;
}
.step-bar .line {
  width: 25px;
  height: 2px;
  background: #e5e7eb;
  margin: 0 8px;
}
.step-bar .line.done {
  background: #0fb864;
}
/* 提示信息 */
.info-tip {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 12px;
  padding: 16px;
  margin: 16px 20px;
  display: flex;
  gap: 10px;
}
.tip-icon {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  background: #dbeafe;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tip-text {
  font-size: 13px;
  color: #165DFF;
  line-height: 1.5;
}
/* 表单区域 */
.form-section {
  padding: 0 20px 20px;
}
.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}
.section-title::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 18px;
  background: #165DFF;
  margin-right: 8px;
}
.form-card {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
}
/* 费用卡片 */
.price-box {
  text-align: center;
  font-size: 64px;
  font-weight: bold;
  color: #1a1a1a;
  background: #f9fafb;
  border-radius: 12px;
  padding: 20px 0;
}
.unit {
  font-size: 24px;
  color: #666;
}
.benefit-list {
  margin-top: 20px;
}
.benefit-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #333;
  margin-bottom: 12px;
}
/* 账户信息 */
.account-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.account-item:last-child {
  margin-bottom: 0;
}
.label {
  font-size: 13px;
  color: #666;
}
.value {
  font-size: 13px;
  color: #333;
}
.value.red {
  color: #ff4d4f;
  font-weight: bold;
}
.account-code-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}
.copy-btn {
  width: 36px;
  height: 36px;
  background: #f5f7fa;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pay-qrcode-card {
  margin-top: 18px;
  padding-top: 18px;
  border-top: 1px solid #eef1f5;
  text-align: center;
}
.pay-qrcode-title {
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 600;
}
.pay-qrcode-img {
  width: 190px;
  height: 190px;
  margin: 14px auto 10px;
  border-radius: 10px;
  object-fit: contain;
  background: #fff;
  box-shadow: 0 6px 18px rgba(31,45,61,.08);
}
.pay-qrcode-tip {
  color: #86909c;
  font-size: 12px;
  line-height: 1.6;
}
/* 上传区域 */
.upload-box {
  border: 1px solid #ccc;
  border-radius: 12px;
  padding: 30px;
  text-align: center;
  background: #fff;
  position: relative;
}
.native-file-input {
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.upload-text {
  font-size: 14px;
  color: #333;
  margin: 10px 0 4px;
}
.upload-tip {
  font-size: 12px;
  color: #aaa;
}
/* 文件预览 */
.file-preview {
  margin-top: 16px;
  background: #e6ffed;
  border-radius: 12px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.preview-img {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: cover;
}
.file-info {
  flex: 1;
}
.file-name {
  font-size: 13px;
  color: #1a1a1a;
  margin-bottom: 4px;
}
.file-status {
  font-size: 11px;
  color: #0fb864;
}
.delete-btn {
  width: 36px;
  height: 36px;
  background: #ffebee;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 提交按钮 */
.submit-btn {
  width: calc(100% - 40px);
  margin: 0 20px;
  background: #165DFF;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 16px;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(22, 93, 255, 0.3);
}
.submit-btn.disabled {
  background: #bcd7ff;
  box-shadow: none;
}
.tip-text {
  text-align: center;
  font-size: 11px;
  color: #999;
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/join/third.vue